import {
    Button,
    Heading,
    useAuthenticator,
    useTheme,
    View,
    Text,
} from "@aws-amplify/ui-react";

import { useTranslation } from "react-i18next";

export const AmplifyUICustomComponents = {
    Footer() {
        const { tokens } = useTheme();
        const { t } = useTranslation("locale");

        return (
            <View
                data-testid="auth-rights"
                textAlign="center"
                padding={`${tokens.space.xl} 0 ${tokens.space.xl} 0`}
            >
                <Text color={tokens.colors.neutral[80]} placeholder="">
                    &copy; {t("auth.rights")}
                </Text>
            </View>
        );
    },

    SignIn: {
        Header() {
            const { tokens } = useTheme();
            const { t } = useTranslation("locale");

            return (
                <Heading
                    data-testid="sign-in-title"
                    padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
                    level={3}
                    placeholder=""
                >
                    {t("auth.sign_in_title")}
                </Heading>
            );
        },
        Footer() {
            const { toResetPassword } = useAuthenticator();
            const { tokens } = useTheme();
            const { t } = useTranslation("locale");

            return (
                <View padding={`0 0 ${tokens.space.xl}  0`} textAlign="center">
                    <Button
                        fontWeight="normal"
                        onClick={toResetPassword}
                        size="small"
                        variation="link"
                        placeholder=""
                    >
                        {t("auth.reset_password")}
                    </Button>
                </View>
            );
        }
    },

    SignUp: {
        Header() {
            const { tokens } = useTheme();
            const { t } = useTranslation("locale");

            return (
                <Heading
                    data-testid="sign-up-title"
                    padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`}
                    level={3}
                    placeholder=""
                >
                    {t("auth.sign_up_title")}
                </Heading>
            );
        },
        Footer() {
            const { toSignIn } = useAuthenticator();
            const { tokens } = useTheme();
            const { t } = useTranslation("locale");

            return (
                <View padding={`0 0 ${tokens.space.xl}  0`} textAlign="center">
                    <Button
                        fontWeight="normal"
                        onClick={toSignIn}
                        size="small"
                        variation="link"
                        placeholder=""
                    >
                        {t("auth.back_to_sign_in")}
                    </Button>
                </View>
            );
        }
    },
    ConfirmSignUp: {
        Header() {
            const { t } = useTranslation("locale");
            return <Heading level={3} placeholder="">{t("auth.enter_information")}</Heading>;
        }
    },
    SetupTOTP: {
        Header() {
            const { t } = useTranslation("locale");
            return <Heading level={3} placeholder="">{t("auth.enter_information")}</Heading>;
        }
    },
    ConfirmSignIn: {
        Header() {
            return <Heading level={3} placeholder="">Enter Information:</Heading>;
        }
    },
    ResetPassword: {
        Header() {
            const { t } = useTranslation("locale");
            return (
                <Heading level={3} placeholder="">{t("auth.reset_password_title")}</Heading>
            );
        }
    },
    ConfirmResetPassword: {
        Header() {
            const { t } = useTranslation("locale");
            return (
                <View>
                    <Heading level={3} placeholder="">{t("auth.enter_information")}</Heading>
                    <Text className="pt-3 pb-1" placeholder="">{t("auth.code_sent")}</Text>
                </View>
            );
        }
    }
};
